import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NotificationsComponent } from 'app/layout/common/notifications/notifications.component';
import { SharedModule } from 'app/shared/shared.module';
import { CommonModule } from '@angular/common';
import { MatBadgeModule } from '@angular/material/badge';

@NgModule({
  declarations: [
    NotificationsComponent
  ],
    imports: [
        RouterModule,
        OverlayModule,
        CommonModule,
        SharedModule,
        PortalModule,
        MatButtonModule,
        MatIconModule,
        MatTooltipModule,
        SharedModule,
        MatBadgeModule
    ],
  exports: [
    NotificationsComponent
  ]
})
export class NotificationsModule {
}
